import { ReactNode } from 'react';
import { clsx } from 'clsx';
import { Tooltip, TooltipExtendedProps } from '../tooltip/Tooltip';
import { useMemoizedDataIds } from '../shared/utils/dataId';
import { INPUT_CONTROL_WITH_LABEL_DATA_IDS } from './inputControlWithLabelDataId';
import styles from './InputControlWithLabel.module.scss';

export interface InputControlLabelProps {
  dataId: string;
  label: ReactNode;
  labelClasses?: string;
  children?: ReactNode;
  control: ReactNode;
  className?: string;
  disabled?: boolean;
  controlTooltipProps?: Partial<TooltipExtendedProps>;
}
export function InputControlWithLabel({
  dataId,
  label,
  labelClasses,
  children,
  className,
  control,
  disabled,
  controlTooltipProps
}: InputControlLabelProps) {
  const dataIds = useMemoizedDataIds(INPUT_CONTROL_WITH_LABEL_DATA_IDS, dataId);

  return (
    <div className={clsx(styles.inputControlWithLabel, className)} data-id={dataIds.container}>
      <div className='flex-shrink-0 d-flex'>
        {controlTooltipProps ? (
          <Tooltip
            dataId={dataIds.tooltip}
            title={controlTooltipProps.title}
            {...controlTooltipProps}
          >
            <span data-id={dataIds.control}>{control}</span>
          </Tooltip>
        ) : (
          control
        )}
      </div>

      <div
        data-id={dataIds.labelContainer}
        className={clsx([styles.text, disabled && styles.disabled])}
      >
        <label
          data-id={dataIds.label}
          className={clsx('text-body-2', labelClasses)}
          htmlFor={dataId}
        >
          {label}

          {children ? (
            <div
              data-id={dataIds.children}
              className={clsx('text-body-1 text-secondary mt-1', disabled && 'text-disabled')}
            >
              {children}
            </div>
          ) : null}
        </label>
      </div>
    </div>
  );
}
